/**
 * A few words in a pill, one of them chosen. On a phone it says which column is showing (03 §layout), and `dot`
 * marks the other one when something in it has changed since it was last looked at.
 */
export function Toggle<T extends string>({ value, onChange, options, dot }: {
  value: T;
  onChange: (v: T) => void;
  options: ReadonlyArray<readonly [T, string]>;
  dot?: T | undefined;
}) {
  return (
    <div className="inline-flex bg-line rounded-full p-[3px] gap-0.5 shrink-0">
      {options.map(([v, label]) => (
        <button
          key={v}
          onClick={() => onChange(v)}
          aria-pressed={value === v}
          className={`relative px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${value === v ? "bg-panel text-ink shadow-sm" : "text-muted"}`}
        >
          {label}
          {dot === v && value !== v ? <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-coral" aria-hidden /> : null}
        </button>
      ))}
    </div>
  );
}
